<template>
  <UiLink v-bind="$attrs" class="wrapper" :title="title" v-on="$listeners">
    <UiBaseIcon width="16px" height="16px" color="#007AFF" icon-name="plusCircle" class="icon" />
    <span>{{ title }}</span>
  </UiLink>
</template>

<script>
import UiBaseIcon from '@/components/icons/UiBaseIcon.vue'
import UiLink from '@/components/UiLink.vue'
export default {
  components: {
    UiBaseIcon,
    UiLink,
  },
  props: {
    title: {
      type: String,
      default: 'Добавить',
    },
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  margin: 0 0 rem(16px) 0;

  @include createFlex(flexbox, nowrap, row, flex-start, center, center);

  .icon {
    margin: -1px rem(8px) 0 0;
  }
}
</style>
